define('controller/step/datetime/FlexibleProviderDateTimeStep',['require','controller/step/datetime/BaseDateTimeStep','collection/ProviderTimeCollection','view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderView'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var ProviderTimeCollection = require('collection/ProviderTimeCollection');
    var TimeFlexibleProviderView = require('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderView');

    return BaseDateTimeStep.extend({

        _timeCollection: null,
        _providerCollection: null,
        _serviceCollection: null,


        initialize: function () {
            BaseDateTimeStep.prototype.initialize.call(this);

            this.listenTo(this._stepManager, 'step:init:service', this.initServiceCollection);
            this.listenTo(this._stepManager, 'step:init:provider', this.initProviderCollection);

            this.listenTo(this._bookingModel, 'change:provider_id', this.updateInfo);
            this.listenTo(this._timeCollection, 'sync', this.updateInfo);

            this._stepManager.getStepObject('service');
            this._stepManager.getStepObject('provider');
        },

        initProviderCollection: function (step, collection) {
            this._providerCollection = collection;
        },

        initServiceCollection: function (step, collection) {
            this._serviceCollection = collection;
        },


        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new ProviderTimeCollection();
        },


        _updateTimeCollection: function () {
            if (this._serviceCollection) {
                this._serviceCollection.performFilters();
            }
            if (this._providerCollection) {
                this._providerCollection.performFilters();
            }

            return BaseDateTimeStep.prototype._updateTimeCollection.apply(this, arguments);
        },


        /**
         * Fetches time collection from server
         */
        _fetchTimeCollection: function () {
            var date = this._bookingModel.get('start_date');
            date = date ? Date.parseMysqlDate(date) : new Date();

            this._timeCollection.fetch({
                data: {
                    'from': date.getMysqlDate(),
                    'to': date.getMysqlDate(),
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'count': this._bookingModel.get('count')
                }
            });
        },

        /**
         * Returns time view
         *
         * @return TimeFlexibleView
         */
        _getTimeView: function () {
            var view = new TimeFlexibleProviderView({
                model: this._bookingModel,
                collection: this._timeCollection,
                calendarCollection: this._calendarCollection,
                bookingModel: this._bookingModel,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });

            // suppose provider could be already selected, then just update time...
            this.listenTo(view, 'timeChanged', this._updateSelectedTime);

            // ... or select both provider and time
            var _this = this;
            this.listenTo(view, 'timeAndProviderChanged', function (time, date, provider) {
                _this._bookingModel.set('provider_id', provider);

                _this._updateSelectedTime(time, date);
            });

            return view;
        },

        updateInfo: function () {
            if (this._timeCollection) {
                var model = this._timeCollection.get(this._bookingModel.get('provider_id'));
                if (model) {
                    this._bookingModel.set('provider', model.get('provider'));
                }
            }
        }

    });

});

